import {
  Component,
  HostListener,
  EventEmitter,
  Output,
  TemplateRef,
  ElementRef,
  ViewChild,
  Renderer2,
  Input,
  OnInit,
} from '@angular/core';

import { environment } from '../../../../environments/environments';
import { IconsComponent } from '../../../editor/additional/icons/icons.component';
import { CommonModule } from '@angular/common';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { ApidataService } from '../../../apidata.service';
import { IconService } from '../../../editor/icons/icon.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { LanguageComponent } from '../../../language/language.component';
import { DictionaryComponent } from '../../../dictionary/dictionary.component';
import { ShareComponent } from '../../../share/share.component';
import { ComposeEmailComponent } from '../../../compose-email/compose-email.component';
import { LogoutComponent } from '../../../logout/logout.component';
import { SupportComponent } from '../../../support/support.component';
import { LoginModalComponent } from '../../../login-modal/login-modal.component';
import { SaveFileComponent } from '../../../save-file/save-file.component';
import { DownloadComponent } from '../../../download/download.component';
import { UploadComponent } from '../../../upload/upload.component';
import swal from 'sweetalert2';

import { SidebarNewCompComponent } from '../../sidebar-new-comp/sidebar-new-comp.component';
import { RouterModule } from '@angular/router';

declare var $: any;
declare var Dropbox: any;
declare var gapi: any;
declare var google: any;
declare var FB: any;
declare var window: any;

interface NavbarLinksType {
  icon: string;
  to?: string;
  function?: () => any;
  text: string;
  p: string;
  submenu?: Omit<NavbarLinksType, 'submenu' | 'icon'>[];
}

@Component({
  selector: 'app-new-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    IconsComponent,
    SidebarNewCompComponent,
    RouterModule,
  ],
  templateUrl: './new-sidebar.component.html',
  styleUrl: './new-sidebar.component.css',
})
export class NewSidebarComponent {
  sidebarExpanded = false;
  isUserLoggedin: boolean = false;

  ngOnInit() {
    this.profile_id = localStorage.getItem('profile_id');
    if (!this.profile_id) {
      this.profile_id = '1';
      this.isUserLoggedin = false;
    } else {
      this.isUserLoggedin = true;
    }
    this.route.paramMap.subscribe((params) => {
      this.doc_id = params.get('doc_id');
      //  console.log('ID from route:', this.doc_id);
    });
    if (!this.doc_id) {
      this.route.queryParams.subscribe((params) => {
        this.doc_id = params['doc'];
      });
    }
  }

  trackByText(index: number, item: any) {
    return item.text;
  }
  navbarLinksLogIn = [
    {
      icon: 'allTools',
      to: '',
      text: 'All Tools',

      submenu: [
        { text: 'Grammar Checker', function: this.saveTextRedirect.bind(this) },
        {
          text: 'Plagiarism Checker',
          function: this.navigatetoplag.bind(this),
        },

        {
          text: 'Paraphrasing Tool',
          function: this.navigatetoparapharsing.bind(this),
        },
        {
          text: 'Article Rewriter',
          function: this.navigatetoarticle.bind(this),
        },
        {
          text: 'Text Summarizer',
          function: this.navigatetotext.bind(this).bind(this),
        },
      ],
    },
    {
      icon: 'writeIcon',
      function: this.newDoc.bind(this),
      p: 'grammar',
      text: 'New',
    },
    {
      icon: 'uploadIcon',
      function: this.uploadFiles.bind(this),
      p: 'openUpload',
      text: 'Upload',
    },
    {
      icon: 'openIcon',
      function: this.navigatetoopenfile.bind(this),
      text: 'Open',
    },
    {
      icon: 'saveIcon',
      function: this.openSave.bind(this),
      p: 'savefile',
      text: 'Save',
    },
    {
      icon: 'downloadIcon',
      function: this.openDownlaodFiles.bind(this),
      p: 'downloadfile',
      text: 'Download',
    },
    {
      icon: 'shareIcon',
      function: this.openShare.bind(this),
      text: 'Share',
    },
    {
      icon: 'esubmissionIcon',
      function: this.openComposeEmail.bind(this),
      p: 'sendemail',
      text: 'E-Submission',
    },
    {
      icon: 'languageIcon',
      function: this.openLanguage.bind(this),
      text: 'Language',
    },
    {
      icon: 'dictionaryIcon',
      function: this.openDictionary.bind(this),
      text: 'Dictionary',
    },
    {
      icon: 'accountIcon',
      function: this.navigatetoaccount.bind(this),
      text: 'Account',
    },
    {
      icon: 'supportIcon',
      function: this.openSupport.bind(this),
      text: 'Support',
    },

    {
      icon: 'logoutIcon',
      function: this.openLogout.bind(this),
      text: 'Logout',
    },
  ];

  navbarLinksNotLogIn = [
    {
      icon: 'allTools',
      to: '',
      text: 'All Tools',
      submenu: [
        { text: 'Grammar Checker', function: this.saveTextRedirect.bind(this) },
        {
          text: 'Plagiarism Checker',
          function: this.navigatetoplag.bind(this),
        },

        {
          text: 'Paraphrasing Tool',
          function: this.navigatetoparapharsing.bind(this),
        },
        {
          text: 'Article Rewriter',
          function: this.navigatetoarticle.bind(this),
        },
        {
          text: 'Text Summarizer',
          function: this.navigatetotext.bind(this),
        },
      ],
    },
    {
      icon: 'writeIcon',
      function: this.openSignInSignUpMpdal.bind(this),
      p: 'grammar',
      text: 'New',
    },
    {
      icon: 'uploadIcon',
      function: this.openSignInSignUpMpdal.bind(this),
      p: 'openUpload',
      text: 'Upload',
    },
    {
      icon: 'openIcon',
      function: this.openSignInSignUpMpdal.bind(this),
      text: 'Open',
    },
    {
      icon: 'saveIcon',
      function: this.openSignInSignUpMpdal.bind(this),
      p: 'savefile',
      text: 'Save',
    },
    {
      icon: 'downloadIcon',
      function: this.openSignInSignUpMpdal.bind(this),
      p: 'downloadfile',
      text: 'Download',
    },
    {
      icon: 'shareIcon',
      function: this.openSignInSignUpMpdal.bind(this),
      text: 'Share',
    },
    {
      icon: 'esubmissionIcon',
      function: this.openSignInSignUpMpdal.bind(this),
      p: 'sendemail',
      text: 'E-Submission',
    },
    {
      icon: 'languageIcon',
      function: this.openSignInSignUpMpdal.bind(this),
      text: 'Language',
    },
    {
      icon: 'dictionaryIcon',
      function: this.openSignInSignUpMpdal.bind(this),
      text: 'Dictionary',
    },
    {
      icon: 'accountIcon',
      function: this.openSignInSignUpMpdal.bind(this),
      text: 'Account',
    },
    {
      icon: 'supportIcon',
      function: this.openSignInSignUpMpdal.bind(this),
      text: 'Support',
    },
  ];

  checkLoginStatus() {
    this.profile_id = localStorage.getItem('profile_id');

    if (!this.profile_id) {
      this.profile_id = '1';
      this.isUserLoggedin = false;
    } else {
      this.isUserLoggedin = true;
    }
  }

  profile_id = '';
  public loaderAlert: boolean = false;

  public doc_id = '';

  @ViewChild('fileInputs') fileInputs;
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  constructor(
    private router: Router,
    private apirequest: ApidataService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private el: ElementRef,
    private IconService: IconService
  ) {
    this.checkLoginStatus();
  }

  toggleSidebarExpanded() {
    this.sidebarExpanded = !this.sidebarExpanded;
  }
  saveTextRedirect() {
    if (this.doc_id) {
      this.router.navigate(['/grammar-check'], {
        queryParams: { doc: this.doc_id },
      });

      return;
    }
  }
  newDoc() {
    let data2 = JSON.stringify({ homeText: '', profile_id: this.profile_id });
    let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';
    this.apirequest.postResources(data2, url).subscribe((data) => {
      let receivedData = data;

      this.doc_id = receivedData['new_doc_id'];
      // this.router.navigate(['/document/', this.doc_id]);
      // this.router.navigate(['/grammar-check'], {
      //   queryParams: { doc: this.doc_id },
      // });
      // $('.ql-editor').text('');
      // setTimeout(() => {
      //   window.location.reload();
      // }, 0);

      // open /grammar-check/doc_id in new tab
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/grammar-check'], {
          queryParams: { doc: this.doc_id },
        })
      );
      window.open(url, '_blank');
    });
    this.loaderAlert = false;
  }
  navigatetohome() {
    this.router.navigate(['/']);
  }
  navigatetohelpcenter() {
    this.router.navigate(['/help-center']);
  }
  navigatetoSignin() {
    this.router.navigate(['/signin']);
  }
  navigatetoSignUp() {
    this.router.navigate(['/signup']);
  }

  openLanguage() {
    const modalRef = this.modalService.open(LanguageComponent, {
      ariaLabelledBy: 'modal-basic-title',
    });
    setTimeout(() => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        modalElement.classList.remove('modal');
      }
    }, 100);
  }

  openLogout() {
    const modalRef = this.modalService.open(LogoutComponent, {
      ariaLabelledBy: 'modal-basic-title',
    });
    setTimeout(() => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        modalElement.classList.remove('modal');
      }
    }, 100);
  }
  openDictionary() {
    const modalRef = this.modalService.open(DictionaryComponent, {
      ariaLabelledBy: 'modal-basic-title',
    });
    modalRef.componentInstance.reloadData();
    setTimeout(() => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        modalElement.classList.remove('modal');
      }
    }, 100);
  }
  openShare() {
    const modalRef = this.modalService.open(ShareComponent, {
      ariaLabelledBy: 'modal-basic-title',
    });
    setTimeout(() => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        modalElement.classList.remove('modal');
      }
    }, 100);
  }
  openSupport() {
    const modalRef = this.modalService.open(SupportComponent, {
      ariaLabelledBy: 'modal-basic-title',
    });
    setTimeout(() => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        modalElement.classList.remove('modal');
      }
    }, 100);
  }
  openComposeEmail() {
    const modalRef = this.modalService.open(ComposeEmailComponent, {
      ariaLabelledBy: 'modal-basic-title',
    });

    setTimeout(() => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        modalElement.classList.remove('modal');
      }
    }, 100);
  }

  openSave() {
    const modalRef = this.modalService.open(SaveFileComponent, {
      ariaLabelledBy: 'modal-basic-title',
    });

    setTimeout(() => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        modalElement.classList.remove('modal');
      }
    }, 100);
  }

  openDownlaodFiles() {
    this.modalService.open(DownloadComponent, {
      ariaLabelledBy: 'modal-basic-title',
    });
    setTimeout(() => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        modalElement.classList.remove('modal');
      }
    }, 100);
  }

  uploadFiles() {
    this.modalService.open(UploadComponent, {
      ariaLabelledBy: 'modal-basic-title',
    });
    setTimeout(() => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        modalElement.classList.remove('modal');
      }
    }, 100);
  }

  openSignInSignUpMpdal() {
    this.modalService.open(LoginModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
    });
    setTimeout(() => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        modalElement.classList.remove('modal');
      }
    }, 100);
  }

  navigatetoplagifnotloggedin() {
    var editortxt = '';
    editortxt = document.getElementById('mm').textContent;
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/plagiarism-checker'])
    );
    window.open(url, '_blank');
  }
  navigatetoparapharsingnotloggedin() {
    var editortxt = '';
    editortxt = document.getElementById('mm').textContent;
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/paraphrasing-tool'])
    );
    window.open(url, '_blank');
  }
  navigatetoarticlenotloggedin() {
    var editortxt = '';
    editortxt = document.getElementById('mm').textContent;
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/article-rewriter'])
    );
    window.open(url, '_blank');
  }
  navigatetotextnotloggedin() {
    var editortxt = '';
    editortxt = document.getElementById('mm').textContent;
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/text-summarizer'])
    );
    window.open(url, '_blank');
  }
  navigatetoplag() {
    const mmElement =
      document.getElementById('mm') || document.getElementById('editor');

    const mmText = mmElement?.textContent?.trim() || '';

    const textToStore = mmText;

    if (textToStore) {
      localStorage.setItem('editorValueAI', textToStore);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/plagiarismchecker'], {
          queryParams: { doc: this.doc_id },
        })
      );
      // console.log('this.doc_id', this.doc_id);
      window.open(url, '_blank');
    } else {
      // console.log('No text content found in either "mm" or "editor" element');
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/plagiarismchecker'], {
          queryParams: { doc: this.doc_id },
        })
      );
      // console.log('this.doc_id', this.doc_id);
      window.open(url, '_blank');
    }
  }

  navigatetoparapharsing() {
    const mmElement =
      document.getElementById('mm') || document.getElementById('editor');

    const mmText = mmElement?.textContent?.trim() || '';

    const textToStore = mmText;

    if (textToStore) {
      localStorage.setItem('editorValueAI', textToStore);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/paraphrasing'], {
          queryParams: { doc: this.doc_id },
        })
      );
      window.open(url, '_blank');
    } else {
      // console.log('No text content found in either "mm" or "editor" element');
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/paraphrasing'], {
          queryParams: { doc: this.doc_id },
        })
      );
      window.open(url, '_blank');
    }
  }

  navigatetotext() {
    const mmElement =
      document.getElementById('mm') || document.getElementById('editor');

    const mmText = mmElement?.textContent?.trim() || '';

    const textToStore = mmText;

    if (textToStore) {
      localStorage.setItem('editorValueAI', textToStore);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/textsummarizer'], {
          queryParams: { doc: this.doc_id },
        })
      );
      window.open(url, '_blank');
    } else {
      // console.log('No text content found in either "mm" or "editor" element');
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/textsummarizer'], {
          queryParams: { doc: this.doc_id },
        })
      );
      window.open(url, '_blank');
    }
  }
  navigatetoai() {
    this.router.navigate(['/aitext/', this.doc_id]);
  }

  navigatetoarticle() {
    const mmElement =
      document.getElementById('mm') || document.getElementById('editor');

    const mmText = mmElement?.textContent?.trim() || '';

    const textToStore = mmText;

    if (textToStore) {
      localStorage.setItem('editorValueAI', textToStore);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/article'], {
          queryParams: { doc: this.doc_id },
        })
      );
      window.open(url, '_blank');
    } else {
      // console.log('No text content found in either "mm" or "editor" element');
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/article'], {
          queryParams: { doc: this.doc_id },
        })
      );
      window.open(url, '_blank');
    }
  }
  navigatetoEditor() {
    this.router.navigate(['/editor/', this.doc_id]);
    window.location.reload;
  }

  navigatetoopenfile() {
    localStorage.setItem('previousdoc', JSON.stringify(this.doc_id));

    this.router.navigate(['/openfile']).then(() => {
      window.location.reload();
    });
  }

  navigatetoaccount() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/accountsettings'])
    );
    window.open(url, '_blank');
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['']);
  }
  isModalVisible: boolean = false;
}
